// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3SFr3","author":"Table_author__3tVvT","authorImage":"Table_authorImage__DagVv","unreadRow":"Table_unreadRow__CIdHv"};